import axios from '../helpers/axios-auth';

class inquireService {
  register(data) {
    return axios.post('/auth/price-inquiry-negotation', data);
  }

  getList() {
    return axios.get('/auth/price-inquiry-negotations');
  }

  registerToInquire(itemList = []) {
    return axios.post('/auth/temp-price-inquiry', itemList);
  }

  getInquireList() {
    return axios.get('/auth/temp-price-inquiry/');
  }

  statusExpire() {
    return axios.put('/auth/set-expire-status/');
  }

  checkout() {
    return axios.get('/auth/checkout');
  }

  removeFromInquire(idList = []) {
    return axios.post('/auth/remove-temp-price-inquiry-checkout', idList);
  }
}
export default new inquireService();
